<template>
  <ModalElement :title :icon ref="modalRef">
    <p class="paragraph" v-html="message"></p>
    <div class="buttons buttons--right">
      <ButtonElement :color="yesColor || 'success'" @click="onYes" :icon="PhCheck">{{
        yesLabel || 'Oui'
      }}</ButtonElement>
      <ButtonElement :color="noColor || 'danger'" bordered @click="onNo" :icon="PhX">{{
        noLabel || 'Non'
      }}</ButtonElement>
    </div>
  </ModalElement>
</template>

<script setup lang="ts">
import ModalElement from '@/components/ModalElement.vue'
import ButtonElement from '@/components/ButtonElement.vue'
import { PhCheck, PhX } from '@phosphor-icons/vue'
import { type Ref, ref, useTemplateRef } from 'vue'

const modalRef = useTemplateRef<typeof ModalElement>('modalRef')

const emit = defineEmits(['yes', 'no'])
let item: undefined | object | string | number | boolean = undefined
const title: Ref<string> = ref('')
const message: Ref<string> = ref('')
const icon: Ref<object | undefined> = ref(undefined)
const yesLabel: Ref<string> = ref('')
const yesColor: Ref<string> = ref('')
const noLabel: Ref<string> = ref('')
const noColor: Ref<string> = ref('')

function show(
  value: object | string | number | boolean,
  confirmTitle: string = '',
  confirmMessage: string = '',
  confirmIcon: object | undefined = undefined,
  confirmYesLabel: string = '',
  confirmYesColor: string = '',
  confirmNoLabel: string = '',
  confirmNoColor: string = '',
) {
  item = value
  title.value = confirmTitle
  message.value = confirmMessage
  icon.value = confirmIcon
  yesLabel.value = confirmYesLabel
  yesColor.value = confirmYesColor
  noLabel.value = confirmNoLabel
  noColor.value = confirmNoColor
  // on affiche la modale de confirmation
  modalRef.value?.show()
}

function hide() {
  item = undefined
  modalRef.value?.hide()
}

function onYes() {
  emit('yes', item)
  modalRef.value?.hide()
}
function onNo() {
  emit('no', item)
  modalRef.value?.hide()
}

defineExpose({ show, hide })
</script>
